module.exports = __webpack_public_path__ + "static/media/sr-graph-right.38817b2f.svg";